import React, { useEffect } from 'react';
import {useModal} from "./useModal";

const Modal = props => {
    const {closeModal} = useModal();

    useEffect(() => {
        focusFirstField();
        document.addEventListener('keydown', closeOnEsc);

        return () => {
            document.removeEventListener('keydown', closeOnEsc);
        };
    }, []);

    const focusFirstField = () => {
        const modals = document.querySelectorAll('.modal');
        const firstInput = modals[modals.length - 1].querySelector('input') || modals[modals.length - 1].querySelector('button');

        if (!firstInput) {
            return;
        }

        firstInput.focus();
    };

    const closeOnEsc = (e) => {
        if (e.keyCode !== 27) {
            return;
        }

        closeModal(props.modalId);
    };

    const { children, wide, className } = props;

    if (!children) {
        return '';
    }

    return (
        <section className={`modal is-active animate ${className ? className : ''}`}>
            <div className="modal__wrapper">
                <section className={`modal__content ${wide ? 'modal__content--wide' : ''}`}>
                    {children}
                </section>
            </div>
        </section>
    );
};

export default Modal;